/* this file is transformed by vux-loader */

/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    msg: {
      type: String,
      default: function _default() {
        return '考勤打卡失败';
      }
    },
    time: {
      type: String,
      default: function _default() {
        return ' ';
      }
    },
    ctn: {
      type: String,
      default: function _default() {
        return '未在考勤范围内，无法打卡';
      }
    }
  },
  data: function data() {
    return {
      img_src: require('@/assets/face/position_fail.png'),
      show: true,
      message: '',
      img: require('@/assets/face/position_success.png')
    };
  },
  watch: {
    msg: {
      handler: function handler(newMsg) {
        this.message = newMsg;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    closeDialg: function closeDialg() {
      this.$emit('closeDialog');
    }
  },
  created: function created() {},
  mounted: function mounted() {}
};